import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { LANGUAGES, resources } from './resources';

// language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
export const getCurrentLanguage = () =>
  localStorage.getItem('choosedLanguage') || navigator.language.includes('fr') ? LANGUAGES.fr_FR : LANGUAGES.en_US

i18n.use(initReactI18next).init({
  resources,
  lng: getCurrentLanguage(),
  fallbackLng: [LANGUAGES.fr_FR],
  supportedLngs: [LANGUAGES.fr, LANGUAGES.fr_FR, LANGUAGES.en, LANGUAGES.en_US],
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;



